import { Faqs, Pros } from 'context/page-form-context';
import { MelFields } from 'modules/mel-ai';
import { PropsWithChildren } from 'react';

import { MelRegenButton } from '../mel-regen-button';
import styles from './mel-wrapper.module.scss';

interface MelWrapperProps extends PropsWithChildren {
  disabled?: boolean;
  fieldName: MelFields;
  fieldRecord?: Faqs | Pros;
  fieldValue?: string;
  onApplyMel?: (values: string | Pros | Faqs) => void;
}

const MelWrapper = ({
  children,
  disabled,
  fieldName,
  fieldRecord,
  fieldValue,
  onApplyMel,
}: MelWrapperProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.children}>{children}</div>
      {!disabled && (
        <div className={styles.btnContainer}>
          <MelRegenButton
            fieldName={fieldName}
            fieldRecord={fieldRecord}
            fieldValue={fieldValue}
            onApplyMel={onApplyMel}
          />
        </div>
      )}
    </div>
  );
};

export { MelWrapper };
